import type { NotificationFields } from '@tribeplatform/gql-client/graphql'
import type {
  QueryMemberNotificationSettingsArgs,
  QueryMemberPostNotificationSettingsArgs,
  QueryNotificationsArgs,
  QuerySpaceDefaultNotificationSettingsArgs,
} from '@tribeplatform/gql-client/types'
import type { MemberNotificationSettingsFields } from '@tribeplatform/gql-client/types/generated'

import { KeyConstructor } from './keyConstructor.js'

const NOTIFICATIONS_KEY = 'notifications'
const NOTIFICATIONS_COUNT_KEY = 'notificationsCount'
const MEMBER_NOTIFICATION_SETTINGS = 'memberNotificationSettings'
const MEMBER_POST_NOTIFICATION_SETTINGS = 'memberPostNotificationSettings'
const SPACE_DEFAULT_NOTIFICATION_SETTINGS = 'spaceDefaultNotificationSettings'

export const getMemberNotificationSettingsKey = KeyConstructor<
  QueryMemberNotificationSettingsArgs,
  MemberNotificationSettingsFields
>(MEMBER_NOTIFICATION_SETTINGS)

export const getMemberPostNotificationSettingsKey = KeyConstructor<
  QueryMemberPostNotificationSettingsArgs,
  never
>(MEMBER_POST_NOTIFICATION_SETTINGS)
export const getNotificationsKey = KeyConstructor<
  QueryNotificationsArgs,
  NotificationFields
>(NOTIFICATIONS_KEY)
export const getNotificationsCountKey = KeyConstructor<never, never>(
  NOTIFICATIONS_COUNT_KEY,
)
export const getSpaceDefaultNotificationSettingsKey = KeyConstructor<
  QuerySpaceDefaultNotificationSettingsArgs,
  never
>(SPACE_DEFAULT_NOTIFICATION_SETTINGS)
